import "katex/dist/katex.min.css";
import Latex from 'react-latex-next';
// $ -> используется между Latex , используется для понимания где  находится текст для формирования Latex
export const MyLatexComponent = ({ text }: any) => {
    return (
        text && <Latex>
            ${text}$
        </Latex>
    )
}
